import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { useDialogKeyboard, DialogKeyboardConfig } from 'lib/hooks/useDialogKeyboard';
import { closeModal } from '../Modal';
import './index.scss';

interface DialogProps {
  title: string | ReactElement;
  children: ReactElement;
  confirmButtonText?: string;
  closeButtonText?: string;
  customClass?: string;
  showClose?: boolean;
  closeCallback?: () => void;
  closeModalWhenClose?: boolean;
  keyboard?: DialogKeyboardConfig;
}

const Dialog = ({
  title,
  children,
  showClose = true,
  customClass = '',
  closeCallback,
  closeModalWhenClose = true,
  keyboard,
}: DialogProps) => {
  const closeDialog = () => {
    if (closeModalWhenClose) {
      closeModal();
    }
    closeCallback?.();
  };

  useDialogKeyboard({
    onEnter: keyboard?.onEnter ?? false,
    onEscape: keyboard?.onEscape ?? (showClose ? closeDialog : false),
    allowEnterInInput: keyboard?.allowEnterInInput,
  });

  return (
    <div className={classNames('modal-dialog-v2', customClass)}>
      {showClose ? (
        <div className="modal-dialog-v2__close-wrapper" onClick={closeDialog}>
          <div className="modal-dialog-v2__close"></div>
        </div>
      ) : null}
      {title ? <div className="modal-dialog-v2__title">{title}</div> : null}
      {children}
    </div>
  );
};

export default Dialog;
